import { defineMessages } from 'react-intl';

export default defineMessages({
  shareNumber: {
    id: 'coupon.shareNumber',
    defaultMessage: '{number}份',
  },
  discoutLevel: {
    id: 'coupon.discoutLevel',
    defaultMessage: '{dishNumText}可享{discount}折',
  },
  benefit: {
    id: 'coupon.benefit',
    defaultMessage: '优惠',
  },
  switchBenefit: {
    id: 'coupon.switchBenefit',
    defaultMessage: '切换优惠',
  },
  purchaseBenefit: {
    id: 'coupon.purchaseBenefit',
    defaultMessage: '加价购满赠',
  },
  singleProductBenefit: {
    id: 'coupon.singleProductBenefit',
    defaultMessage: '单商品优惠',
  },
  notUseBenefit: {
    id: 'coupon.notUseBenefit',
    defaultMessage: '未使用优惠',
  },
  benefitCoupon: {
    id: 'coupon.benefitCoupon',
    defaultMessage: '优惠券',
  },
  cannotBeSharedWith: {
    id: 'coupon.cannotBeSharedWith',
    defaultMessage: '不可与{info}共享',
  },
  maxCouponNumPrefix: {
    id: 'coupon.maxCouponNumPrefix',
    defaultMessage: '最多可以使用',
  },
  maxCouponNumSuffix: {
    id: 'coupon.maxCouponNumSuffix',
    defaultMessage: '张优惠券',
  },
  pickedCouponNumPrefix: {
    id: 'coupon.pickedCouponNumPrefix',
    defaultMessage: '已选',
  },
  pickedCouponNumSuffix: {
    id: 'coupon.pickedCouponNumSuffix',
    defaultMessage: '张',
  },
  manjianCoupon: {
    id: 'coupon.manjianCoupon',
    defaultMessage: '满减券',
  },
  zhekouCoupon: {
    id: 'coupon.zhekouCoupon',
    defaultMessage: '折扣券',
  },
  ptlipinCoupon: {
    id: 'coupon.ptlipinCoupon',
    defaultMessage: '礼品券',
  },
  cplipinCoupon: {
    id: 'coupon.cplipinCoupon',
    defaultMessage: '商品券',
  },
  daijinCoupon: {
    id: 'coupon.daijinCoupon',
    defaultMessage: '代金券',
  },
  useRules: {
    id: 'coupon.useRules',
    defaultMessage: '使用规则',
  },
  usePeriod: {
    id: 'coupon.usePeriod',
    defaultMessage: '使用时段',
  },
  thisCoupon: {
    id: 'coupon.thisCoupon',
    defaultMessage: '本券',
  },
  distributionMode: {
    id: 'coupon.distributionMode',
    defaultMessage: '可用配送方式:',
  },
  send: {
    id: 'coupon.send',
    defaultMessage: '外卖',
  },
  self: {
    id: 'coupon.self',
    defaultMessage: '自提',
  },
  couponAvailableInSomeStores: {
    id: 'coupon.availableInSomeStores',
    defaultMessage: '部分门店可用',
  },
  couponAvailableInAllStores:{
    id: 'coupon.availableInAllStores',
    defaultMessage: '全部门店可用',
  },
  couponViewUseableStores:{
    id: 'coupon.viewUseableStores',
    defaultMessage: '查看适用门店',
  },
  couponAvailableStores:{
    id: 'coupon.availableStores',
    defaultMessage: '适用门店',
  },
  couponTooLate: {
    id: 'coupon.TooLate',
    defaultMessage: '来晚了，活动结束啦',
  },
  couponWarnLong: {
    id: 'coupon.couponWarnLong',
    defaultMessage:
      '当前选择优惠与单商品/多商品优惠不能通用，是否取消单商品/多商品优惠，选择优惠券',
  },
  couponWarnLong2: {
    id: 'coupon.couponWarnLong2',
    defaultMessage:
      '当前选择优惠与加价购/满赠促销不能通用，是否取消加价购/满赠促销，选择优惠券',
  },
  couponWarnLong3: {
    id: 'coupon.couponWarnLong3',
    defaultMessage:
      '当前选择优惠与整单优惠不能通用，是否取消整单优惠，选择优惠券',
  },
  couponWarnLong4: {
    id: 'coupon.couponWarnLong4',
    defaultMessage:
      '当前选择优惠与单商品优惠/加价购不能通用，是否取消单商品优惠/加价购，选择优惠券',
  },
  couponShareRedBag: {
    id: 'couponShareRedBag',
    defaultMessage: '给您发红包了！数量有限，先到先得',
  },
  couponFastComeFastGet: {
    id: 'couponFastComeFastGet',
    defaultMessage: '数量有限，先到先得!',
  },
  couponUseCouponProcess: {
    id: 'couponUseCouponProcess',
    defaultMessage: '长按扫码关注>去点餐>下单使用优惠劵!',
  },
  couponFillToUse: {
    id: 'common.fillToUse',
    defaultMessage: '满{value}可用',
  },
  couponNoThreshold: {
    id: 'couponNoThreshold',
    defaultMessage: '无门槛',
  },
  couponShareToFriends: {
    id: 'couponShareToFriends',
    defaultMessage: '立即分享给好友',
  },
  couponUseNow: {
    id: 'couponUseNow',
    defaultMessage: '立即使用',
  },
  couponShareDiscount: {
    id: 'couponShareDiscount',
    defaultMessage: '分享优惠',
  },
  couponShareSuccess: {
    id: 'couponShareSuccess',
    defaultMessage: '分享成功',
  },
  couponFocus: {
    id: 'couponFocus',
    defaultMessage: '关注门店',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/coupon/index.js